var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    y: 0.25,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#00AF9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 27.9203C16.584 27.9203 13 24.418 13 20.0851C13 15.7601 16.584 12.25 21 12.25C25.424 12.25 29 15.7601 29 20.0851C29 24.418 25.424 27.9203 21 27.9203ZM23.5523 22.9922C23.6483 23.047 23.7523 23.0783 23.8643 23.0783C24.0643 23.0783 24.2643 22.9765 24.3763 22.7884C24.5443 22.5142 24.4563 22.1538 24.1683 21.9814L21.3203 20.3204V16.7005C21.3203 16.3714 21.0483 16.1129 20.7203 16.1129C20.3923 16.1129 20.1203 16.3714 20.1203 16.7005V20.6573C20.1203 20.861 20.2323 21.049 20.4163 21.1587L23.5523 22.9922Z",
    fill: "#00AF9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.07063e510c7f8ab16e5a44854f65270c.svg";
export { ForwardRef as ReactComponent };